import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, Shield, HelpCircle } from 'lucide-react';

const FAQSection = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: t('faq_section.q1'),
      answer: t('faq_section.a1')
    },
    {
      question: t('faq_section.q2'),
      answer: t('faq_section.a2')
    },
    {
      question: t('faq_section.q3'),
      answer: t('faq_section.a3')
    },
    {
      question: t('faq_section.q4'),
      answer: t('faq_section.a4')
    },
    {
      question: t('faq_section.q5'),
      answer: t('faq_section.a5')
    },
    {
      question: t('faq_section.q6'),
      answer: t('faq_section.a6')
    }
  ];

  return (
    <section data-testid="faq-section" className="py-16 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <HelpCircle className="w-4 h-4" />
            {t('faq_section.badge')}
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            {t('faq_section.title')}
          </h2>
          <p className="text-lg text-slate-600">
            {t('faq_section.subtitle')}
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`border rounded-xl overflow-hidden transition-all ${
                openIndex === index 
                  ? 'border-blue-300 bg-blue-50/50 shadow-sm' 
                  : 'border-slate-200 bg-white hover:border-slate-300'
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full flex items-center justify-between p-5 text-left"
                data-testid={`faq-question-${index}`}
              >
                <span className={`font-semibold pr-4 ${openIndex === index ? 'text-blue-900' : 'text-slate-900'}`}>
                  {faq.question}
                </span>
                <ChevronDown 
                  className={`w-5 h-5 flex-shrink-0 transition-transform ${
                    openIndex === index ? 'rotate-180 text-blue-600' : 'text-slate-400'
                  }`} 
                />
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-slate-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Risk Reversal / Guarantee Box */}
        <div className="mt-12 bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 md:p-8 border-2 border-green-200">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="w-20 h-20 bg-green-100 rounded-2xl flex items-center justify-center flex-shrink-0">
              <Shield className="w-10 h-10 text-green-600" />
            </div>
            <div className="text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-bold text-green-900 mb-2">
                {t('faq_section.guarantee_title')}
              </h3>
              <p className="text-green-700 leading-relaxed">
                {t('faq_section.guarantee_text')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
